import { useSelector } from "react-redux";
import { ThemeTypes } from "@/utils/constants";

export const useIsDarkTheme = () => {
  const profile = useSelector((state) => state.profile);
  return profile.data?.webTheme?.id === ThemeTypes.dark.id;
};
